/**
 * HelloWorld
 * ======================================
 * - example js module
 */

const MESSAGE = "Hello World! From HelloWorld.js";

export class HelloWorld {
  constructor() {
    window.addEventListener("load", this.loadHandler, false);
  }

  loadHandler = () => {
    console.log(MESSAGE);
  };
}

new HelloWorld();
